import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

import RegisterTry from '../pages/RegisterTry'
import Login from '../pages/Login'
import Password from '../pages/Password'
import Planning from '../pages/Planning'
import Preview from '../pages/Sheet'
import Admin from '../pages/Admin'
import Top from '../pages/Top'
import RegisterUser from '../pages/RegisterUser'
import Unit from '../pages/Unit'
import Master from '../pages/Master'
import Output from '../pages/Output'
import PropertyPreview from '../pages/PropertyPreview'
import List from '../pages/List'
import PriceSetting from '../pages/PriceSetting'
import Error from '../pages/Error'
import Forbidden from '../pages/Forbidden'
import NotFound from '../pages/NotFound'
import Health from '../pages/Health-check'
import Order from '../pages/OrderList'
import OrderDetail from '../pages/OrderDetail'
import OrderManager from '../pages/OrderManager'
import ContentsData from '../pages/ContentsData'

// mmstyle
import DcTop from '../payment/pages/DcTop'
import DcUserManageer from '../payment/pages/DcUserManager'
import SendMail from '../payment/pages/SendMail'
import SendMailComp from '../payment/pages/SendMailComplete'
import DcLogin from '../payment/pages/Login'
import RegisterCorp from '../payment/pages/RegistCorpInput'
import RegistUserInput from '../payment/pages/RegistUserInput'
import RegistUserConfirm from '../payment/pages/RegistUserConfirm'
import RegistUserComplete from '../payment/pages/RegistUserComplete'
import UpdateCorpInput from '../payment/pages/UpdateCorpInput'
import UpdateUserInput from '../payment/pages/UpdateUserInput'
import UpdateAccountConfirm from '../payment/pages/UpdateAccountConfirm'
import UpdateAccountComplete from '../payment/pages/UpdateAccountComplete'
import UpdateAccountInput from '../payment/pages/UpdateAccountInput'
import UpdatePasswordInput from '../payment/pages/UpdatePasswordInput'
import UpdateUserConfirm from '../payment/pages/UpdateUserConfirm'
import OrderInput from '../payment/pages/OrderInput'
import OrderConfirm from '../payment/pages/OrderConfirm'
import ConstructInput from '../payment/pages/ConstructInput'
import OrderComplate from '../payment/pages/OrderComplete'
import SupportInput from '../payment/pages/SupportInput'
import SupportConfirm from '../payment/pages/SupportConfirm'
import SupportComplete from '../payment/pages/SupportComplete'
import UseRule from '../payment/pages/UseRule'
import Faq from '../payment/pages/Faq'
import What from '../payment/pages/WhatMmStyle'
import DcError from '../payment/pages/Error'
import UnSupported from '../components/common/UnSupported'
import PasswordResetInput from '../payment/pages/PasswordResetInput'
import PasswordResetConfirm from '../payment/pages/PasswordResetConfirm'
import PasswordResetUpdate from '../payment/pages/PasswordResetUpdate'
import PasswordResetComplete from '../payment/pages/PasswordResetComplete'
import BuildingResearchBusiness from '../payment/pages/BuildingResearchBusiness'
import BuildingResearchInput from '../payment/pages/BuildingResearchInput'
import BuildingResearchConfirm from '../payment/pages/BuildingResearchConfirm'
import BuildingResearchComplete from '../payment/pages/BuildingResearchComplete'
import FirstPassword from '../payment/pages/FirstPassword'
import SaveItemList from '../payment/pages/SaveItemList'
import Cart from '../payment/pages/Cart'
import OrderHistoryList from '../payment/pages/DcOrderHistoryList'
import OrderHistoryDetail from '../payment/pages/DcOrderHistoryDetail'
import DcProfitSetting from '../payment/pages/DcProfitSetting'

//
import DcCustomize from '../payment/pages/DcCustomize'

// Kagull
import KgTop from '../kagull/pages/KgTop'
import KgLogin from '../kagull/pages/Login'
import KgRegistUserTop from '../kagull/pages/RegistUserTop'
import KgRegistUserInput from '../kagull/pages/RegistUserInput'
import KgRegistUserComplete from '../kagull/pages/RegistUserComplete'
import KgPasswordResetTop from '../kagull/pages/PasswordResetTop'
import KgPasswordResetMailConfirm from '../kagull/pages/PasswordResetMailConfirm'
import KgPasswordResetUpdate from '../kagull/pages/PasswordResetUpdate'
import KgPasswordResetUpdateConfirm from '../kagull/pages/PasswordResetUpdateConfirm'
import KgPasswordResetComplete from '../kagull/pages/PasswordResetComplete'
import KgFpCategory from '../kagull/pages/FpCategory'
import KgFpSelect from '../kagull/pages/FpSelect'
import KgFpSize from '../kagull/pages/FpSize'
import KgOrderInput from '../kagull/pages/OrderInput'
import KgOrderConfirm from '../kagull/pages/OrderConfirm'
import KgOrderComplete from '../kagull/pages/OrderComplete'
import KgSheetPreview from '../kagull/pages/SheetPreview'
import KgAbout from '../kagull/pages/About'
import KgFaq from '../kagull/pages/Faq'
import KgContactInput from '../kagull/pages/ContactInput'
import KgContactConfirm from '../kagull/pages/ContactConfirm'
import KgContactComplete from '../kagull/pages/ContactComplete'
import KgSurveyInput from '../kagull/pages/SurveyInput'
import KgSurveyComplete from '../kagull/pages/SurveyComplete'
import KgNews from '../kagull/pages/News'
import KgNewsDetail from '../kagull/pages/NewsDetail'
import KgMyPage from '../kagull/pages/MyPage'
import KgError from '../kagull/pages/Error'

import {API_URL, APP_NAME, DC_APP_NAME, PTN_DC, KG_APP_NAME, PTN_KG, PTN_KG_SHEET} from '../constants/App'
import * as Api from '../utils/Api'
import * as AppUtil from '../utils/App'
import * as Check from '../utils/Check'
import {LICENSE_TYPE} from '../constants/Type'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Top',
      component: Top,
      meta: {
        requiresAuth: true,
        notPermitTrial: true
      }
    },
    {
      path: '/health-check',
      name: 'Health',
      component: Health,
      meta: {
        title: 'ヘルスチェック'
      }
    },
    {
      path: '/register-try',
      name: 'RegisterTry',
      component: RegisterTry,
      meta: {}
    },
    {
      path: '/register-user',
      name: 'RegisterUser',
      component: RegisterUser,
      meta: {
        title: 'ユーザー登録'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'ログイン'
      }
    },
    {
      path: '/password',
      name: 'Password',
      component: Password,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/unit',
      name: 'Unit',
      component: Unit,
      meta: {
        title: 'ユニット登録',
        requiresAuth: true,
        notPermitTrial: true
      }
    },
    {
      path: '/planning',
      name: 'Planning',
      component: Planning,
      meta: {
        title: 'プランニング',
        requiresAuth: true
      }
    },
    {
      path: '/preview',
      name: 'Preview',
      component: Preview,
      meta: {
        title: 'プレビュー',
        requiresAuth: true
      }
    },
    {
      path: '/plan/list',
      name: 'Order',
      component: Order,
      meta: {
        title: '受注リスト',
        requiresAuth: true
      }
    },
    {
      path: '/plan/detail',
      name: 'OrderDetail',
      component: OrderDetail,
      meta: {
        title: '受注表',
        requiresAuth: true
      }
    },
    {
      path: '/plan/manager',
      name: 'OrderManager',
      component: OrderManager,
      meta: {
        title: '受注管理',
        requiresAuth: true
      }
    },
    {
      path: '/contentsdata',
      name: 'ContentsData',
      component: ContentsData,
      meta: {
        title: 'コンテンツデータ',
        requiresAuth: true
      }
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin,
      meta: {
        title: '管理画面',
        requiresAuth: true
      }
    },
    {
      path: '/master',
      name: 'Name',
      component: Master,
      meta: {
        title: 'マスター登録',
        requiresAuth: true,
        notPermitTrial: true
      }
    },
    {
      path: '/output',
      name: 'Output',
      component: Output,
      meta: {
        title: '出力物生成',
        requiresAuth: true,
        notPermitTrial: true
      }
    },
    {
      path: '/property_preview',
      name: 'PropertyPreview',
      component: PropertyPreview,
      meta: {
        title: '物件情報プレビュー',
        requiresAuth: true,
        notPermitTrial: true
      }
    },
    {
      path: '/list',
      name: 'List',
      component: List,
      meta: {
        title: 'プラン管理',
        requiresAuth: true,
        notPermitTrial: true
      }
    },
    {
      path: '/admin/price_setting',
      name: 'PriceSetting',
      component: PriceSetting,
      meta: {
        title: '価格管理',
        requiresAuth: true
      }
    },
    // 事前現場調査入力画面
    {
      path: '/mmstyle/research/business',
      name: 'BuildingResearchBusiness',
      component: BuildingResearchBusiness,
      meta: {
        title: '事前現場調査内容入力'
      }
    },
    // 事前現場調査入力画面
    {
      path: '/mmstyle/research/input',
      name: 'BuildingResearchInput',
      component: BuildingResearchInput,
      meta: {
        title: '事前現場調査内容入力'
      }
    },
    // 事前現場調査確認画面
    {
      path: '/mmstyle/research/confirm',
      name: 'BuildingResearchConfirm',
      component: BuildingResearchConfirm,
      meta: {
        title: '事前現場調査依頼確認'
      }
    },
    // 事前現場調査完了画面
    {
      path: '/mmstyle/research/complete',
      name: 'BuildingResearchComplete',
      component: BuildingResearchComplete,
      meta: {
        title: '事前現場調査依頼完了'
      }
    },
    // mmstyle初回ログイン画面
    {
      path: '/mmstyle/password',
      name: 'FirstPassword',
      component: FirstPassword
    },
    // デジタルカタログ ログイン
    {
      path: '/mmstyle/login',
      name: 'DcLogin',
      component: DcLogin,
      meta: {
        title: 'ログイン'
      }
    },
    // デジタルカタログ
    {
      path: '/mmstyle/top',
      name: 'DcTop',
      component: DcTop,
      meta: {
        title: 'トップ',
        requiresAuth: true,
        requireMessenger: true
      }
    },
    // デジタルカタログ
    {
      path: '/mmstyle/user/manager',
      name: 'DcUserManageer',
      component: DcUserManageer,
      meta: {
        title: 'ユーザ管理',
        requiresAuth: true,
        requireMessenger: true
      }
    },
    // ECサイト 仮メール送信
    {
      path: '/mmstyle/user/mail',
      name: 'SendMail',
      component: SendMail,
      meta: {
        title: 'ユーザ仮登録メール送信'
      }
    },
    // デジタルカタログ 仮メール送信完了
    {
      path: '/mmstyle/user/mail-comp',
      name: 'SendMailComp',
      component: SendMailComp,
      meta: {
        title: 'ユーザ仮登録メール送信完了'
      }
    },
    // デジタルカタログ 企業新規登録
    {
      path: '/mmstyle/user/register-corp',
      name: 'RegisterCorp',
      component: RegisterCorp,
      meta: {
        title: '企業情報登録'
      }
    },
    // デジタルカタログ ユーザ新規登録
    {
      path: '/mmstyle/user/register-user',
      name: 'RegistUserInput',
      component: RegistUserInput,
      meta: {
        title: 'ユーザ情報入力'
      }
    },
    // デジタルカタログ ユーザ新規登録
    {
      path: '/mmstyle/user/confirm',
      name: 'RegistUserConfirm',
      component: RegistUserConfirm,
      meta: {
        title: 'ユーザ登録確認'
      }
    },
    // デジタルカタログ ユーザ新規登録
    {
      path: '/mmstyle/user/complete',
      name: 'RegistUserComplete',
      component: RegistUserComplete,
      meta: {
        title: 'ユーザ登録完了'
      }
    },
    // デジタルカタログ ユーザ情報 更新
    {
      path: '/mmstyle/user/update-corp',
      name: 'UpdateCorpInput',
      component: UpdateCorpInput,
      meta: {
        title: '企業情報入力',
        requiresAuth: true
      }
    },
    // デジタルカタログ ユーザ情報 更新
    {
      path: '/mmstyle/user/update-user',
      name: 'UpdateUserInput',
      component: UpdateUserInput,
      meta: {
        title: 'ユーザ情報入力',
        requiresAuth: true
      }
    },
    // デジタルカタログ アカウント情報 更新入力
    {
      path: '/mmstyle/user/update-account-input',
      name: 'UpdateAccountInput',
      component: UpdateAccountInput,
      meta: {
        title: 'アカウント情報入力',
        requiresAuth: true
      }
    },
    // デジタルカタログ アカウント情報 更新確認
    {
      path: '/mmstyle/user/update-account-confirm',
      name: 'UpdateAccountConfirm',
      component: UpdateAccountConfirm,
      meta: {
        title: 'アカウント更新確認',
        requiresAuth: true
      }
    },
    // デジタルカタログ アカウント情報 更新確認
    {
      path: '/mmstyle/user/reset/update-account',
      name: 'UpdateAccountComplete',
      component: UpdateAccountComplete,
      meta: {
        title: 'アカウント更新完了'
      }
    },
    // デジタルカタログ パスワード情報 更新
    {
      path: '/mmstyle/user/update-password',
      name: 'UpdatePasswordInput',
      component: UpdatePasswordInput,
      meta: {
        title: 'パスワード情報入力',
        requiresAuth: true
      }
    },
    // デジタルカタログ ユーザ情報 確認
    {
      path: '/mmstyle/user/update-confirm',
      name: 'UpdateUserConfirm',
      component: UpdateUserConfirm,
      meta: {
        title: 'ユーザ登録確認',
        requiresAuth: true,
        requireMessenger: true
      }
    },
    // デジタルカタログ 利用規約
    {
      path: '/mmstyle/user/use-rule',
      name: 'UseRule',
      component: UseRule,
      meta: {
        title: '利用規約',
        requireMessenger: true
      }
    },
    {
      path: '/mmstyle/order/input',
      name: 'OrderInput',
      component: OrderInput,
      meta: {
        title: '注文入力',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/order/confirm',
      name: 'OrderConfirm',
      component: OrderConfirm,
      meta: {
        title: '注文確認',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/order/complete',
      name: 'OrderComplate',
      component: OrderComplate,
      meta: {
        title: '注文完了',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/order/construct',
      name: 'ConstructInput',
      component: ConstructInput,
      meta: {
        title: '組立設置',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/support/input',
      name: 'SupportInput',
      component: SupportInput,
      meta: {
        title: 'お問い合わせ入力'
      }
    },
    {
      path: '/mmstyle/support/confirm',
      name: 'SupportConfirm',
      component: SupportConfirm,
      meta: {
        title: 'お問い合わせ確認'
      }
    },
    {
      path: '/mmstyle/support/complete',
      name: 'SupportComplete',
      component: SupportComplete,
      meta: {
        title: 'お問い合わせ完了'
      }
    },
    {
      path: '/mmstyle/faq',
      name: 'Faq',
      component: Faq,
      meta: {
        title: 'よくある質問',
        requireMessenger: true
      }
    },
    {
      path: '/mmstyle/what',
      name: 'What',
      component: What,
      meta: {
        title: 'mm/styleとは',
        requireMessenger: true
      }
    },
    {
      path: '/mmstyle/user/reset/input',
      name: 'PasswordResetInput',
      component: PasswordResetInput,
      meta: {
        title: 'パスワードリセット'
      }
    },
    {
      path: '/mmstyle/user/reset/confirm',
      name: 'PasswordResetConfirm',
      component: PasswordResetConfirm,
      meta: {
        title: 'パスワードリセット完了'
      }
    },
    {
      path: '/mmstyle/user/reset/update',
      name: 'PasswordResetUpdate',
      component: PasswordResetUpdate,
      meta: {
        title: 'パスワードリセット'
      }
    },
    {
      path: '/mmstyle/user/reset/complete',
      name: 'PasswordResetComplete',
      component: PasswordResetComplete,
      meta: {
        title: 'パスワードリセット完了'
      }
    },
    {
      path: '/mmstyle/save/itemlist',
      name: 'SaveItemList',
      component: SaveItemList,
      meta: {
        title: '商品保存リスト',
        requireMessenger: true
      }
    },
    {
      path: '/mmstyle/cart',
      name: 'Cart',
      component: Cart,
      meta: {
        title: 'カート',
        requireMessenger: true
      }
    },
    {
      path: '/mmstyle/order/history',
      name: 'OrderHistoryList',
      component: OrderHistoryList,
      meta: {
        title: '注文履歴',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/order/history/detail',
      name: 'OrderHistoryDetail',
      component: OrderHistoryDetail,
      meta: {
        title: '注文履歴詳細',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/top/profit',
      name: 'DcProfitSetting',
      component: DcProfitSetting,
      meta: {
        title: '価格表示設定',
        requiresAuth: true
      }
    },
    {
      path: '/mmstyle/top/customize',
      name: 'DcCustomize',
      component: DcCustomize,
      meta: {
        title: 'カスタマイズ',
        requiresAuth: true
      }
    },
    // カグル
    {
      path: '/kagull/login',
      name: 'KgLogin',
      component: KgLogin,
      meta: {
        title: 'ログイン'
      }
    },
    {
      path: '/kagull/user/registtop',
      name: 'KgRegistUserTop',
      component: KgRegistUserTop,
      meta: {
        title: 'ユーザー登録'
      }
    },
    {
      path: '/kagull/user/registinput',
      name: 'KgRegistUserInput',
      component: KgRegistUserInput,
      meta: {
        title: 'ユーザー登録'
      }
    },
    {
      path: '/kagull/user/registcomplete',
      name: 'KgRegistUserComplete',
      component: KgRegistUserComplete,
      meta: {
        title: 'ユーザー登録完了'
      }
    },
    {
      path: '/kagull/top',
      name: 'KgTop',
      component: KgTop,
      meta: {
        title: 'トップ',
        requiresAuth: true
      }
    },
    {
      path: '/kagull/planning/category',
      name: 'KgFpCategory',
      component: KgFpCategory,
      meta: {
        title: '家具製作',
        requiresAuth: true
      }
    },
    {
      path: '/kagull/planning/select',
      name: 'KgFpSelect',
      component: KgFpSelect,
      meta: {
        title: '家具製作',
        requiresAuth: true
      }
    },
    {
      path: '/kagull/planning/size',
      name: 'KgFpSize',
      component: KgFpSize,
      meta: {
        title: 'サイズ入力',
        requiresAuth: true
      }
    },
    {
      path: '/kagull/order/input',
      name: 'KgOrderInput',
      component: KgOrderInput,
      meta: {
        title: '注文入力',
        requiresAuth: true
      }
    },
    {
      path: '/kagull/order/confirm',
      name: 'KgOrderConfirm',
      component: KgOrderConfirm,
      meta: {
        title: '注文入力確認画面',
        requiresAuth: true
      }
    },
    {
      path: '/kagull/order/complete',
      name: 'KgOrderComplete',
      component: KgOrderComplete,
      meta: {
        title: '注文完了',
        requiresAuth: true
      }
    },
    {
      path: '/kagull/sheet',
      name: 'KgSheetPreview',
      component: KgSheetPreview,
      meta: {
        title: '図面プレビュー',
        requiresAuth: true
      }
    },
    {
      path: '/kagull/user/reset/top',
      name: 'KgPasswordResetTop',
      component: KgPasswordResetTop,
      meta: {
        title: 'パスワードリセット'
      }
    },
    {
      path: '/kagull/user/reset/mailconfirm',
      name: 'KgPasswordResetMailConfirm',
      component: KgPasswordResetMailConfirm,
      meta: {
        title: 'パスワードリセット完了'
      }
    },
    {
      path: '/kagull/user/reset/update',
      name: 'KgPasswordResetUpdate',
      component: KgPasswordResetUpdate,
      meta: {
        title: 'パスワードリセット'
      }
    },
    {
      path: '/kagull/user/reset/updateconfirm',
      name: 'KgPasswordResetUpdateConfirm',
      component: KgPasswordResetUpdateConfirm,
      meta: {
        title: 'パスワードリセット確認'
      }
    },
    {
      path: '/kagull/user/reset/complete',
      name: 'KgPasswordResetComplete',
      component: KgPasswordResetComplete,
      meta: {
        title: 'パスワードリセット完了'
      }
    },
    {
      path: '/kagull/about/:headerType',
      name: 'KgAbout',
      component: KgAbout,
      props: true,
      meta: {
        title: 'About'
      }
    },
    {
      path: '/kagull/faq/:headerType',
      name: 'KgFaq',
      component: KgFaq,
      props: true,
      meta: {
        title: 'よくある質問'
      }
    },
    {
      path: '/kagull/support/input/:headerType',
      name: 'KgContactInput',
      component: KgContactInput,
      props: true,
      meta: {
        title: 'お問い合わせ'
      }
    },
    {
      path: '/kagull/support/confirm/:headerType',
      name: 'KgContactConfirm',
      component: KgContactConfirm,
      props: true,
      meta: {
        title: 'お問い合わせ確認'
      }
    },
    {
      path: '/kagull/support/complete/:headerType',
      name: 'KgContactComplete',
      component: KgContactComplete,
      props: true,
      meta: {
        title: 'お問い合わせ完了'
      }
    },
    {
      path: '/kagull/survey/input',
      name: 'KgSurveyInput',
      component: KgSurveyInput,
      meta: {
        title: 'アンケート入力',
        requiresAuth: true
      }
    },
    {
      path: '/kagull/survey/complete',
      name: 'KgSurveyComplete',
      component: KgSurveyComplete,
      meta: {
        title: 'アンケート入力完了',
        requiresAuth: true
      }
    },
    {
      path: '/kagull/news',
      name: 'KgNews',
      component: KgNews,
      meta: {
        title: '  ニュース一覧',
        requiresAuth: true
      }
    },
    {
      path: '/kagull/news/detail',
      name: 'KgNewsDetail',
      component: KgNewsDetail,
      meta: {
        title: '  ニュース詳細',
        requiresAuth: true
      }
    },
    {
      path: '/kagull/mypage',
      name: 'KgMyPage',
      component: KgMyPage,
      meta: {
        title: '  マイページ',
        requiresAuth: true
      }
    },
    // 共通
    {
      path: '/error',
      name: 'Error',
      component: Error,
      meta: {}
    },
    //
    {
      path: '/mmstyle/error',
      name: 'DcError',
      component: DcError,
      meta: {}
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Forbidden,
      meta: {}
    },
    {
      path: '/unsupported',
      name: 'UnSupported',
      component: UnSupported,
      meta: {}
    },
    {
      path: '/mmstyle/unsupported',
      name: 'UnSupported',
      component: UnSupported,
      meta: {}
    },
    {
      path: '/kagull/error',
      name: 'KgError',
      component: KgError,
      meta: {}
    },
    // 必ず最後に定義
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
      meta: {}
    }
  ],
  scrollBehavior (to, from, savePosiotn) {
    return {x: 0, y: 0}
  }
})

// axiosのキャッシュ設定
axios.interceptors.request.use(function (config) {
  if (typeof config.params === 'undefined') {
    config.params = {}
  }
  if (typeof config.params === 'object') {
    if (typeof URLSearchParams === 'function' && config.params instanceof URLSearchParams) {
      config.params.append('_', Date.now())
    } else {
      config.params._ = Date.now()
    }
  }

  return config
})

/** タイトル設定 */
const setTitle = function (to) {
  let component = to.matched.find(e => e.meta.title)
  let url = location.href
  if (PTN_KG.test(url)) {
    document.title = component ? component.meta.title + ' | ' + KG_APP_NAME : KG_APP_NAME
  } else if (PTN_DC.test(url)) {
    document.title = component ? component.meta.title + ' | ' + DC_APP_NAME : DC_APP_NAME
  } else {
    document.title = component ? component.meta.title + ' | ' + APP_NAME : APP_NAME
  }
}

/** Intercomのメッセンジャーの表示 */
const dispMessenger = function (to) {
  window.Intercom('shutdown')
  if (to.matched.some(e => e.meta.requireMessenger)) {
    window.Intercom('boot', {
      app_id: 'vpld6oei',
      vertical_padding: 1,
      horizontal_padding: 23
    })
  }
}

/** ズームイン・ズームアウトの可否を設定 */
const setUserScaleNo = function () {
  let url = location.href
  let userNoScale = 'user-scalable=no'
  let viewport = document.querySelector('meta[name="viewport"]')
  let viewportContent = viewport.getAttribute('content')
  if (PTN_KG.test(url) && !PTN_KG_SHEET.test(url)) {
    // ズームイン・ズームアウトが不可に設定されていなかったら不可に設定する
    if (!viewportContent.match(userNoScale)) {
      viewport.setAttribute('content', viewportContent + ', ' + userNoScale)
    }
  } else {
    // ズームイン・ズームアウトが不可に設定されていたら可能に設定する
    if (viewportContent.match(userNoScale)) {
      let replaceViewportContent = viewportContent.replace(userNoScale, '').replace(/, $/, '')
      viewport.setAttribute('content', replaceViewportContent)
    }
  }
}

// 画面初期表示時にサーバーアクセスがないものについては、vue-routerの機能を利用して画面描画開始前に認証処理を行う。
router.beforeEach((to, from, next) => {
  if (to.path.indexOf('unsupported') === -1) {
    let url = location.href
    if (PTN_DC.test(url)) {
      if (!Check.brawserCheck()) {
        if (from.path.indexOf('unsupported') >= 0) {
          next(false)
        } else {
          next('/mmstyle/unsupported')
          setTitle(to)
          next()
          dispMessenger(to)
        }
        return
      }
    } else if (!PTN_KG.test(url)) {
      if (!Check.brawserCheckForDaros()) {
        if (from.path.indexOf('unsupported') >= 0) {
          next(false)
        } else {
          next('/unsupported')
          setTitle(to)
          next()
          dispMessenger(to)
        }
        return
      }
    }
  }

  // 画面初期表示時、認証チェック
  if (to.matched.some(e => e.meta.requiresAuth)) {
    axios.get(API_URL.INIT, {
      params: {
        pageUrl: to.path
      }
    }).then(response => {
      // お試しユーザーに許容していない画面はプランニング画面に遷移させる
      if (to.matched.some(e => e.meta.notPermitTrial) && AppUtil.getUserInfo().licenseType === LICENSE_TYPE.TRIAL) {
        router.push('/planning')
      } else {
        setTitle(to)
        next()
        dispMessenger(to)
        setUserScaleNo()
      }
    }).catch(error => {
      Api.handleError(error)
    })
    return
  }
  setTitle(to)
  next()
  dispMessenger(to)
  setUserScaleNo()
})

export default router



// WEBPACK FOOTER //
// ./src/main/js/router/index.js